export enum TypeStaffTask {
    actividad = 1,
    tarea = 2,
    servicio = 3
}
